import { useEffect, useState } from "react";


import "./MainContainer.css";
import LoadingScreen from "../LoadingScreen/LoadingScreen";
import "../../App.css";
import Header from "../Header/Header";
import ProductRange from "../ProductRange/ProductRange";
import CampaCola from "../CampaCola/CampaCola";
import Legacy from "../Legacy/Legacy";
import FizzyMemories from "../FizzyMemories/FizzyMemories";
import Footer from "../Footer/Footer";
import PowerUp from "../PowerUp/PowerUp";
import CampaCricket from "../CampaCricket/CampaCricket";
import HomeTakeoverBanner from "../HomeTakeoverBanner/HomeTakeoverBanner";


const MainContainer = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div>
      <HomeTakeoverBanner />
      {loading ? (
        <LoadingScreen />
      ) : (
        <div>
          <Header />
          <div style={{ overflowX: "hidden" }}>
            <div id="campa-cola">
              <CampaCola />
            </div>
            <div id="legacy">
              <Legacy />
            </div>
            <div id="campa-cricket">
            <CampaCricket/>
            </div>
            <div id="power-up">
            <PowerUp />
            </div>
            <div id="product-range">
            <ProductRange />
            </div>
            <div id="fizzy-memories">
            <FizzyMemories />
            </div>
            <Footer />
          </div>
        </div>
      )}
    </div>
  );
};

export default MainContainer;
